import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getClientUrl } from '~services/utils';  // eslint-disable-line

const propTypes = {
  match: PropTypes.object, // Injected by React Router
};

class Portfolio extends Component {
  componentDidMount() {
    document.querySelector('meta[name="viewport"]').content =
      'width=device-width, initial-scale=1';

    const script = document.createElement('script');

    script.async = true;
    script.src = `${getClientUrl()}/zeckit-portfolio.js`;

    document.body.appendChild(script);
  }

  render() {
    const { match } = this.props;
    const { identifier } = match.params;

    return <div id="zeckit-portfolio" data-company-id={identifier} />;
  }
}

Portfolio.propTypes = propTypes;

export default Portfolio;
